
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch, onUnmounted } from 'vue'
import { RedoOutlined, QuestionCircleFilled, QuestionCircleTwoTone } from '@ant-design/icons-vue'
import { stockpool } from '@/api/index'
import router from '@/router/index'
import axios from 'axios'
import { useRoute } from 'vue-router'
import stock from '@/utils/stock'
import Table from '@/components/asktheSecretary/table.vue'
import store from '@/store/index'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
import WebSocket from '@/components/websocket.vue'
export default defineComponent({
  components: {
    Table,
    RedoOutlined,
    QuestionCircleFilled,
    WebSocket
  },
  setup(props: any, context: any) {
    const store = useStore()
    const route = useRoute()
    const columns = [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
        width: '80px',
        slots: { customRender: 'includeStockInfp' },
        align: 'left'
      },
      {
        title: '最新价',
        dataIndex: 'lastPx',
        key: 'lastPx',
        width: '60px',
        ellipsis: true,
        slots: { customRender: 'lastPrice' },
        align: 'right',
        sorter: (a: any, b: any) => a.lastPx - b.lastPx,
        sortDirections: ['descend', 'ascend', 'descend']
      },
      {
        title: '涨跌幅',
        dataIndex: 'pxChangeRate',
        key: 'pxChangeRate',
        width: '60px',
        slots: { customRender: 'increase' },
        align: 'right',
        // sorter: true,
        defaultSortOrder: 'descend',
        sorter: (a: any, b: any) => a.pxChangeRate - b.pxChangeRate,
        sortDirections: ['descend', 'ascend', 'descend']
      },
      {
        title: '触发价格',
        dataIndex: 'selectedPrice',
        key: 'selectedPrice',
        width: '80px',
        align: 'right',
        slots: { customRender: 'decimal' },
        sorter: (a: any, b: any) => a.selectedPrice - b.selectedPrice,
        sortDirections: ['descend', 'ascend', 'descend']
      }
    ]
    let lefttimer: any = null
    const pageData: any = reactive({
      jsonData: [],
      currentInfo: {},
      list: [],
      tradingDay: '',
      PageID: 1,
      pageSize: 5000,
      loading: false,
      allloaded: false,
      getPopupContainer: (e: any) => e.parentNode
    })
    function getjson() {
      // 读取配置文件json
      let url = process.env.VUE_APP_BASE_API
      if (!location.hostname.includes('test-') && location.hostname !== 'localhost') {
        url = url.replace('test-', '')
      }
      //  https://test-pcstatic.9fh5.com/pc_cfg/H5/pool/IndexPool.json
      url += '/pc_cfg/H5/pool/IndexPool.json' + '?' + Date.now()
      axios.get(url).then((res: any) => {
        pageData.jsonData = res.data
        const currentInfo = pageData.jsonData.filter((item: any) => {
          return item.strategyCode === route.query.strategyCode
        })
        pageData.currentInfo = currentInfo[0]
        getlist(false)
      })
    }
    function getlist(isscroll: boolean) {
      const data: any = {}
      data.data = {
        // tradingDay: ,
        pageNo: pageData.PageID,
        pageSize: pageData.pageSize,
        strategyCode: pageData.currentInfo.strategyCode
      }
      const _time: any = parseInt((new Date().getTime() / 1000) as any) * 1000

      const _signature: any = []
      for (const key in data.data) {
        _signature.push(data.data[key])
      }
      data.headers = {
        clienttype: 'pc',
        appVersion: route.query.appVersion,
        token: route.query.token,
        appcode: route.query.appcode,
        serverId: route.query.serverId || route.query.serverid,
        timestamp: _time,
        'Content-Type': 'application/x-www-form-urlencoded',
        signature: window.Md5.hashStr('sjdxfnqogbzoun13d971ckh8p' + _signature.join('') + _time)
      }
      stockpool.getStockPoolList(data).then((res: any) => {
        const result = res.data
        result.list.forEach((item: any, i: number) => {
          item.increase = item.pxChangeRate
          item.index = i
        })
        if (result.list.length < pageData.pageSize) {
          pageData.allloaded = true
        }
        pageData.tradingDay = window.moment(result.tradingDay).format('MM月DD日')
        pageData.list = result.list
      })
    }
    getjson()
    function gotodetail(row: any) {
      if (!row.Inst) row.Inst = row.symbol
      if (!row.Exch) row.Exch = row.market

      const softNameAbbr = route.query.softNameAbbr
      const versionStr: any = route.query.version || ''
      // const version = parseFloat(versionStr.split('.').join('') || '0')
      /**
       * 擒龙如下：
          softNameAbbr=jfztADV
          version<3.9.0
          不做跳转
          高于3.8.0的版本，可以采用新的跳转命令

          旗舰如下：
          softNameAbbr=jfzt
          version<3.11.0
          不做跳转
          高于3.11.0的版本，可以采用新的跳转命令 ------ 跳转至K线
       */
      if (softNameAbbr === 'jfztADV') {
        const version = versionStr.split('.')
        if ((Number(version[0]) === 3 && version[1] >= 9 && version[2] >= 0) || version[0] > 3) {
          stock.gotoKline(row)
        }
      }
      if (softNameAbbr === 'jfzt') {
        const version = versionStr.split('.')
        if ((Number(version[0]) === 3 && version[1] >= 11 && version[2] >= 0) || version[0] > 3) {
          stock.gotoKline(row)
        }
      }
      if (softNameAbbr === 'dyzt') {
      }
    }
    function fresh() {
      pageData.PageID = 1
      pageData.allloaded = false
      pageData.list = []
      getlist(false)
    }
    function clickRow(name: any) {
      const data = {
        KeyWords: [name]
      }
      pageData.PageID = 1
    }
    function settime() {
      const lel: any = document.querySelector('.ant-table-body')
      lel.onscroll = () => {
        const offsetHeight = lel.offsetHeight
        const scrollTop = lel.scrollTop
        const scrollHeight = lel.scrollHeight
        if (offsetHeight + scrollTop - scrollHeight >= -1 && scrollTop > 0) {
          // 需要执行的代码
          // suboff(pageData.list)
          if (!lefttimer && !pageData.allloaded) {
            pageData.PageID++
            pageData.loading = true
            lefttimer = setTimeout(function () {
              // getData('')
              getlist(true)
              lefttimer = null
              pageData.loading = false
            }, 100)
          }
          if (pageData.allloaded) {
            pageData.loading = false
          }
          // 调用list 原本的数据请求函数
        }
      }
    }

    function websocketonmessage(event: any) {
      if (pageData.list && pageData.list.length) {
        pageData.list.forEach((item: any) => {
          if (item.symbol === JSON.parse(event.data).Inst && (item.market || '').toLowerCase() === JSON.parse(event.data).Market.toLowerCase()) {
            if (JSON.parse(event.data).QuoteData && (JSON.parse(event.data).QuoteData.DynaData || [])[0]) {
              item.DynaData = (JSON.parse(event.data).QuoteData.DynaData || [])[0]
            }
            if (JSON.parse(event.data).QuoteData && (JSON.parse(event.data).QuoteData.StatisticsData || [])[0]) {
              item.StatisticsData = (JSON.parse(event.data).QuoteData.StatisticsData || [])[0]
            }
            if (JSON.parse(event.data).QuoteData && (JSON.parse(event.data).QuoteData.InstStatusData || [])[0]) {
              item.InstStatusData = (JSON.parse(event.data).QuoteData.InstStatusData || [])[0]
            }
            if (item.InstStatusData && item.InstStatusData.StatusType === 6) {
              item.lastPx = null
              item.pxChangeRate = null
            } else {
              item.lastPx = item.LastPrice = item.DynaData ? item.DynaData.LastPrice || null : null
              item.pxChangeRate = item.increase =
                item.DynaData && item.StatisticsData
                  ? ((item.DynaData.LastPrice - item.StatisticsData.PreClosePrice) / item.StatisticsData.PreClosePrice) * 100
                  : null
            }
          }
        })
      }
    }
    // watch(
    //   () => pageData.list,
    //   (newV: any, oldV: any) => {

    //   }
    // )
    return {
      ...toRefs(pageData),
      columns,
      gotodetail,
      fresh,
      websocketonmessage
    }
  }
})
